var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar align-items-center"},[(_vm.is_not_anonymous)?_c('KTQuickUser'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }